export enum InventoryStatus {
  Completed = 'completed',
  Draft = 'draft',
  Incidence = 'incidence',
  Resolved = 'resolved',
}
